import script from "./JournalAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./JournalAnalysis.vue?vue&type=style&index=0&id=9c13fc48&lang=css"

const __exports__ = script;

export default __exports__